import { connect } from "react-redux";

export const withCurrentAccount = () => {
  const mapStateToProps = ({ currentAccount }) => ({ currentAccount });
  return connect(mapStateToProps);
};
